export default __webpack_public_path__ + "static/1735808438-65065865-532x82-PEAK-LOGO-960-7849708963e198cbbdc5a1ec1e5d3852.png";